import { Badge, Group, Radio, Text } from '@mantine/core';

import styles from './TitleDescriptionRadio.module.scss';
import { Props } from './TitleDescriptionRadio.types';

const TitleDescriptionRadio = ({
  title,
  description,
  illustrationIcon,
  disabledLabel,
  ...props
}: Props) => {
  const Icon = illustrationIcon;

  return (
    <Radio.Card className={styles.container} {...props}>
      <Group wrap="nowrap" align="flex-start">
        <Radio.Indicator />
        <div className={styles.content}>
          <Group wrap="nowrap" justify="space-between" className={styles.topRow}>
            <Group wrap="nowrap" align="flex-start">
              <Icon color={'#0e5b61'} size={22} />
              <Text className={styles.typeName}>{title}</Text>
            </Group>
            {disabledLabel && (
              <Badge className={styles.badge} color={'#ED711330'}>
                {disabledLabel}
              </Badge>
            )}
          </Group>
          <Text className={styles.typeDescription}>{description}</Text>
        </div>
      </Group>
    </Radio.Card>
  );
};

export default TitleDescriptionRadio;
